<template>
  <div class="mt-5" v-if="customField.type !== 'timepicker'">
    <label style="font-weight: bold">
      {{ getTitle() }}
      <span v-if="fieldIsRequired">*</span>
    </label>
    <br />
    <input
      v-if="customField.type === 'textinput'"
      type="text"
      @change="updateValue()"
      :required="fieldIsRequired"
      v-model="inputValue"
      :pattern="customField?.regexPattern"
      :title="getTitleForTextInput(customField)"
      :minlength="customField?.length"
      :maxlength="customField?.length"
    />
    <div class="control" v-else-if="customField.type === 'radiobutton'">
      <label
        class="radio"
        v-for="option in customField.options"
        :key="option.title"
        @change="updateValue()"
      >
        <input
          type="radio"
          :name="customField.name"
          :required="fieldIsRequired"
          v-model="inputValue"
          :value="option.value"
        />
        {{ getOptionTitle(option) }}
      </label>
    </div>
    <label
      v-else-if="customField.type === 'checkbox'"
      class="checkbox"
      v-for="option in customField.options"
      :key="option.title"
    >
      <input
        type="checkbox"
        :required="fieldIsRequired"
        v-model="checkboxInputs[option.value]"
        @change="updateValue()"
        :value="option.value"
      />
      {{ getOptionTitle(option) }}
      <span v-if="fieldIsRequired">*</span>
    </label>
    <div class="select" v-else-if="customField.type === 'dropdown'">
      <select
        v-model="inputValue"
        @change="updateValue()"
        :required="customField.mandatory"
      >
        <option></option>
        <option
          v-for="option in customField.options"
          :key="option.title"
          :value="option.value"
        >
          {{ getOptionTitle(option) }}
        </option>
      </select>
    </div>
    <template v-else>
      <span>Als u dit ziet; neem dan contact met ons op (Code: 78u3y7u)</span>
      <p>
        {{ customField }}
      </p>
    </template>
    <p v-if="getDescription()">
      <small>{{ getDescription() }}</small>
    </p>
  </div>
</template>

<script>
import reservationHelper from "@/helpers/reservation.helper";

export default {
  emits: ["settedValue"],
  props: {
    customField: {
      type: Object,
      default: () => {}
    },
    customFieldFormData: {}
  },
  data() {
    return {
      inputValue: "",
      checkboxInputs: []
    };
  },
  computed: {
    fieldIsRequired() {
      return reservationHelper.isFieldMandatory(
        this.customField,
        this.customFieldFormData
      );
    }
  },
  methods: {
    getTitleForTextInput(customField) {
      if (
        customField.validPrefixes &&
        customField.regexPattern &&
        customField.length
      ) {
        return this.$t("ReservationForm.StartsWith", {
          validPrefixes: customField.validPrefixes,
          length: customField.length
        });
      } else {
        return null;
      }
    },
    updateValue() {
      let saveObject = {
        field: this.customField.name
      };
      if (this.customField.type === "checkbox") {
        saveObject.value = [];

        Object.keys(this.checkboxInputs).forEach((key) => {
          if (this.checkboxInputs[key]) {
            saveObject.value.push(key);
          }
        });
      } else {
        saveObject.value = this.inputValue;
      }

      this.$emit("settedValue", saveObject);
    },
    getOptionTitle(option) {
      let translation = option.translations.find(
        (cF) => cF.languageIso == this.languageIso
      );
      return translation ? translation.title : option.value;
    },
    getTranslation() {
      let translation = this.customField.translations.find(
        (cF) => cF.languageIso.toLowerCase() == this.languageIso.toLowerCase()
      );
      return translation;
    },
    getTitle() {
      const translation = this.getTranslation();
      return translation ? translation.title : this.customField.name;
    },
    getDescription() {
      const translation = this.getTranslation();
      if (!translation) {
        return false;
      }
      let description = translation.description;
      if (description !== this.customField.name) {
        return description;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.radio,
.checkbox {
  width: 100%;
  margin-left: 0;
}

.title {
  width: 100%;
}
</style>
